<template>
  <div class="heading-three">
    <h3 class="heading"><slot></slot></h3>
  </div>
</template>

<script>
export default {
  name: "HeadingThree",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.heading-three {
  // margin-bottom: 15px;
  // @include mq-up(md) {
  //   margin-bottom: 30px;
  // }
  margin-bottom: 15px;
  @include mq-up(md) {
    margin-bottom: 30px;
  }
  > .heading {
    color: #333;
    text-align: left;
    font-size: 16px;
    line-height: 24px;
    border-bottom: 1px solid $secondary;
    padding-bottom: 10px;
    @include mq-up(md) {
      font-size: 24px;
      line-height: 32px;
    }
  }
}
</style>
